/*eslint-disable */
define(function(require) {
    var $ = require('jquery');
    var _ = require('underscore');
    var CommonView = require('site/common/view');
    var choiceFormatter = require('common/formatter/choice-formatter');
    var priceFormatter = require('common/formatter/price-formatter');
    var config = require('common/page-config');
    var verifyEmail = require('common/form-validation-rules/verify-email');
    var language = require('common/util/language');

    if (config.alternateAppUri) {
      window.location = config.alternateAppUri;
    }

    var MAX_CHARACTERS = 150;
    var MAX_LINES = 4;

    var checkoutData = config.checkout;
    const tracking = require("site/page/gift-card/gift-card-tracking");

    return CommonView.extend({
        events: {
            'change #gift-card-amount': 'calculateTotal',
            'keyup #gift-card-message' : 'adjustGiftMessage',
            'keydown #gift-card-message': 'limitGiftMessageEntry',
            'click .gift-card-form__step--down .gift-card-button' : 'calculateTotal',
            'click .gift-card-form__step--up .gift-card-button' : 'calculateTotal',
            'keydown #gift-card-quantity': 'verifyQuantity',
            'change #gift-card-quantity': 'verifyQuantity',
            'click .unit:not(.on)' : 'onChangeDeliveryMethod',
            'submit form': 'goToCheckout'
        },

        ui: {
            deliveryMethodWrapper: '.whn-gift-card-delivery-method',
            amount: '#gift-card-amount',
            amountWrapper: '.whn-gift-card-amount',
            quantity: '#gift-card-quantity',
            giftMessage: '#gift-card-message',
            giftMessageCount: '.count-chars',
            email: '#gift-card-email',
            emailWrapper: '.whn-gift-card-email',
            checkoutTotal: '.whn-gift-card-resume > .total > span',
            rightColumnTextEmail: '.whn-message-email',
            rightColumnTextPost: '.whn-message-post',
            rightColumnText: '.whn-gift-card-right-column-text',
            giftcardImage: '.whn-gift-card-picture',
            comingSoonContainer: '.coming-soon-container',
            formFieldsContainer: '.gift-card-form__fields',
            byEmailCta: '#by-email-cta',
            byEmailTab: '.unit.by-email'
        },

        initialize: function(options) {
            this.options = options;
            var $deliveryMethod = this.ui.deliveryMethodWrapper.find('.on');

            this.$('.on').css('background', config.onButtonStyle);
            this.$('.unit').css({'border': '1px solid' + config.onButtonStyle,
                                'color': config.onButtonStyle});
            this.$('.unit.on').css('color', '#fff');


            this.ui.amount.wahandadropdown({
                appendTo: '.whn-gift-card-amount',
                width: this.ui.amount.width() + 6
            });

            this.$el.find('#gift-card-form').validate(this.validation());

            this.options.deliveryMethod = $deliveryMethod.data('delivery-method') || "by-email";
            this.amountDropdown();
            this.emailToggle();
            this.updateMessageCount();
            this.calculateTotal();
            this.ui.byEmailCta.on('click', () => this.ui.byEmailTab.click());
            this.addTracking();

        },

        amountDropdown: function () {
            var amount = this.ui.amount.val();
            var amountValues = config.cms.giftCard.amountValues[this.options.deliveryMethod];
            var amountDefault = (amount) ? amount : config.cms.giftCard.amountDefault;
            var $amountSelect = this.ui.amount;

            $amountSelect.html('');
            _.each(amountValues.split(','), function (elem, index) {
                var tmpl = _.template('<option value="<%= value %>"<%= selected %>><%= price %></option>');
                var data = {
                    value: elem,
                    selected: (amountDefault === elem) ? ' selected' : '',
                    price: priceFormatter.format({amount: elem})
                };
                $amountSelect.append(tmpl(data));
            });
            $amountSelect.wahandadropdown('refresh');
        },

        onChangeDeliveryMethod: function(event) {
            var $deliveryMethod = $(event.currentTarget);
            var $deliveryMethodBtns = this.ui.deliveryMethodWrapper.find('.unit');

                $deliveryMethodBtns.removeClass('on');
                this.$('.unit').css('color', config.onButtonStyle);
                this.$('.unit').css('background', '#fff');

                $deliveryMethod.addClass('on');
                this.$('.on').css('background', config.onButtonStyle);
                this.$('.on').css('color', '#fff');


            this.options.deliveryMethod = $deliveryMethod.data('delivery-method');
            this.amountDropdown();
            this.emailToggle();
            const label = this.options.deliveryMethod === 'by-email' ? 'email' : 'post';
            tracking.trackDeliveryMethodToggle(label);
        },

        goToCheckout: function (e) {
            e.preventDefault();

            var quantity = parseInt(this.ui.quantity.val(), 10);

            if (quantity <= 0 || quantity === '') {
                return false;
            }

            var ids = this.options.deliveryMethod === 'by-email' ? checkoutData.egiftCard : checkoutData.giftCard;
            var offerType = this.options.deliveryMethod === 'by-email' ? 'EGIFT_CARD' : 'GIFT_CARD';

            var offers = [{
                offerId                 : ids.offerId,
                offerType				: offerType,
                skus                    : [{skuId: ids.skuId}],
                amount                  : this.ui.amount.val(),
                quantity                : quantity,
                giftMessage             : this.ui.giftMessage.val()
            }];

            if (offerType === 'EGIFT_CARD') {
                offers[0].recipientEmailAddress = this.ui.email.val()
            }

            var offersParameterValue = encodeURIComponent(JSON.stringify(offers));
            var langPath = language.getLanguagePath(window.location.pathname);

            const checkoutUri = window.location.origin + langPath + '/secure-checkout?offers=' + offersParameterValue;

            return window.location.href = new URL(checkoutUri);
        },

        validation: function() {
            var validation = {
                submitHandler: (form, event) => {
                    tracking.trackGiftCardFormContinue("success");
                    this.goToCheckout(event);
                  },
                invalidHandler: (event, validator) => {
                    const reason = Object.values(validator.errorMap).join(', ');
                    tracking.trackGiftCardFormContinue(`fail: ${reason}`);
                },
                rules: {
                    'gift-card-quantity': {
                        required: true
                    },
                    'gift-card-email': {
                        required: true,
                        remote: verifyEmail($('.email'), config.cms.validationMessages['email-invalid'])
                    },
                    'gift-card-message': {
                        maxlength: 150
                    }
                },
                messages: {
                    'gift-card-email': {
                        required: config.cms.validationMessages['email-required']
                    }
                }
            };

            _.each(this.ui.otherNameFields, function(field) {
                var fieldName = $(field).attr('name');
                validation.rules[fieldName] = {
                        required:true,
                        minlength:3
                };
                validation.messages[fieldName] = {
                        required: config.cms.validationMessages['name-required'],
                        minlength: config.cms.validationMessages['client-name-minlength']
                };
            });

            return validation;
        },

        adjustGiftMessage: function(e) {
            var length = this.ui.giftMessage.val().length;
            if (length <= MAX_CHARACTERS && e.which !== 8) {
                e.preventDefault();
            }
            this.updateMessageCount(length);
        },

        updateMessageCount: function(messageLength) {
            messageLength = messageLength || 0;
            var countTemplate = config.cms.giftCard.messageCount;
            var characterCount = choiceFormatter.format(countTemplate, MAX_CHARACTERS-messageLength);
            this.ui.giftMessageCount.html(characterCount);
        },

        limitGiftMessageEntry: function(e) {
            var length = this.ui.giftMessage.val().length;
            var lineCount = (this.ui.giftMessage.val() || '').split('\n').length;

            if (e.which === 13 && lineCount >= MAX_LINES) {
                e.preventDefault();
            }
            if (length >= MAX_CHARACTERS && e.which !== 8) {
                e.preventDefault();
            }
        },

        verifyQuantity: function (e) {
            if (e.type === 'keydown') {
                // Allow: backspace, delete, tab, escape, enter and .
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                     // Allow: Ctrl+A
                    (e.keyCode === 65 && e.ctrlKey === true) ||
                     // Allow: home, end, left, right
                    (e.keyCode >= 35 && e.keyCode <= 39)) {
                         // let it happen, don't do anything
                         return;
                }
                // Ensure that it is a number and stop the keypress
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                    e.preventDefault();
                }
            }
            if (e.type === 'change') {
                if (this.ui.quantity.val() < 1) {
                    this.ui.quantity.val(1);
                }
                this.calculateTotal();
            }
        },

        calculateTotal: function () {
            var amount = this.ui.amount.val();
            var quantity = this.ui.quantity.val();
            var total = priceFormatter.format({amount: amount*quantity}, true);

            this.ui.checkoutTotal.html(total);
        },

        emailToggle: function () {
            this.ui.rightColumnText.hide();
            if (this.options.deliveryMethod === 'by-email') {
                this.ui.emailWrapper.show();
                this.ui.rightColumnTextEmail.show();
                this.ui.giftcardImage.css("background-image", config.cms.giftCard.eGiftcardImage)
                this.ui.comingSoonContainer.hide()
                this.ui.formFieldsContainer.show()
                return;
            }

            if (this.options.deliveryMethod === 'by-post' ) {
                this.ui.emailWrapper.hide();
                this.ui.rightColumnTextPost.show();
                this.ui.giftcardImage.css("background-image", config.cms.giftCard.postalGiftcardImage)

                if (config.postalGiftCardsEnabled) {
                    this.ui.comingSoonContainer.hide()
                    this.ui.formFieldsContainer.show()
                } else {
                    this.ui.formFieldsContainer.hide()
                    this.ui.comingSoonContainer.show()
                }
            }
        },

        addTracking: function () {
            $('.gift-card-button[data-href="#gift-card-form"]').on('click', 
                () => tracking.trackBuyYoursNow());
            $('.gift-card-button[data-href="#about"]').on('click', 
                () => tracking.trackFindOutMore());
            $('.wh-grey').on('click', tracking.trackGetInTouch);
            $('.email-link').on('click', tracking.trackSendDigitalInstead);
            this.ui.giftMessage.on('focus', tracking.trackFocusGiftCardMessage);
            this.ui.giftMessage.on('blur', () => tracking.trackBlurGiftCardMessage(this.ui.giftMessage.val()));
            this.ui.amount.on('change', (event) => tracking.trackAmountDropdown($(event.currentTarget).val()));
            this.ui.quantity.on('change', (event) => tracking.trackQuantityField($(event.currentTarget).val()));
            $('.whn-gift-card-text .right-col a[href*="/requests/new"]').on('click', (event) => {
                event.preventDefault();
                tracking.trackContactForm(() => window.location = $(event.currentTarget).attr("href"));
            });
            this.ui.email.on('focus', tracking.trackFocusGiftCardEmail);
        },
    });
});
